import React, { useState } from "react";
import { Image, Menu } from "antd";
import horse from "../../assets/images/horse.svg";
import {
  AppstoreOutlined,
  HomeOutlined,
  CalendarOutlined,
  SettingFilled,
  HomeFilled,
} from "@ant-design/icons";

import { RiBarChart2Fill, RiSettings5Fill } from "react-icons/ri";
import { BiCalendarStar } from "react-icons/bi";
import "./navbar.css";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/app_logo.svg";
import { useSelector } from "react-redux";
import { Badge } from "antd";


function NavbarContainer(props) {
  const [current, setCurrent] = useState("home");
  const handleClick = (e) => {
    setCurrent(e.key);
  };

  return (
    <div>
      <Menu
        onClick={handleClick}
        mode="horizontal"
      >
        <Menu.Item className="logo">
          <Link to="/">
            {" "}
            <img src={Logo} style={{ height: 50 }} />
          </Link>
        </Menu.Item>
        <Menu.Item
          key="/"
    
        >
          Home
          <Link to="/" />
        </Menu.Item>
        <Menu.Item
      
          icon={<img src={horse} />}
        >
          <Link to="/my-event" />
          My Event
        </Menu.Item>
        <Menu.Item key="/leaderboard" icon={<RiBarChart2Fill />}>
          <Link to="/leaderboard">Leaderboard</Link>
        </Menu.Item>
        <Menu.Item key="/create-event" icon={<BiCalendarStar />}>
          Create Event
        
        </Menu.Item>
        <Menu.Item key="/settings" icon={<SettingFilled />}>
          <Link to="/settings">
            
              Settings
          </Link>
        </Menu.Item>
      </Menu>
    </div>
  );
}
export default NavbarContainer;
